import { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { clearCheckoutState as clearCheckoutStateAction } from 'dux/checkout/actions';

// Clears all checkout state when unmounts
const CheckoutCleanerContainer = ({ clearCheckoutState }) => {
  useEffect(() => {
    return () => {
      clearCheckoutState();
    };
  });

  return null;
};

CheckoutCleanerContainer.propTypes = {
  clearCheckoutState: PropTypes.func.isRequired,
};

export default connect(() => ({}), { clearCheckoutState: clearCheckoutStateAction })(
  CheckoutCleanerContainer
);
